import React, { Component } from 'react';

class Checkbox extends Component {
    toggleCheckboxChange = () => {
        const { onChange, defaultChecked } = this.props;
        if (typeof onChange === 'function') {
            onChange(!defaultChecked);
        }
    };

    render() {
        const { label, defaultChecked, disabled } = this.props;

        return (
            <div className="Checkbox">
                <input
                    type="checkbox"
                    disabled={disabled || false}
                    checked={defaultChecked || false}
                    onChange={this.toggleCheckboxChange}
                />
                <label>{label}</label>
            </div>
        );
    }
}

export default Checkbox;
